// Terrain types and their gameplay properties. Shared. FROZEN CONTRACT.

export enum Terrain {
  DeepWater = 0,
  Water = 1,
  Sand = 2,
  Grass = 3,
  Fertile = 4,
  Forest = 5,
  Hills = 6,
  Mountain = 7,
  Swamp = 8,
  Snow = 9,
}

export interface TerrainDef {
  name: string
  /** Movement cost multiplier for land units. Infinity = impassable. */
  moveCost: number
  /** Whether buildings may generally be placed here (building defs may further restrict). */
  buildable: boolean
  /** Base color hint (used by minimap; the main renderer has its own richer palette). */
  color: string
}

export const TERRAIN: Record<Terrain, TerrainDef> = {
  [Terrain.DeepWater]: { name: 'Deep Water', moveCost: Infinity, buildable: false, color: '#123a5e' },
  [Terrain.Water]: { name: 'Water', moveCost: Infinity, buildable: false, color: '#2266a0' },
  [Terrain.Sand]: { name: 'Sand', moveCost: 1.25, buildable: true, color: '#d8c07a' },
  [Terrain.Grass]: { name: 'Grassland', moveCost: 1, buildable: true, color: '#6fa653' },
  [Terrain.Fertile]: { name: 'Fertile Plain', moveCost: 1, buildable: true, color: '#4f9944' },
  [Terrain.Forest]: { name: 'Forest', moveCost: 1.6, buildable: false, color: '#39702f' },
  [Terrain.Hills]: { name: 'Hills', moveCost: 2, buildable: true, color: '#8d8a6a' },
  [Terrain.Mountain]: { name: 'Mountains', moveCost: 3, buildable: false, color: '#7a7580' },
  [Terrain.Swamp]: { name: 'Swamp', moveCost: 2.5, buildable: false, color: '#54683f' },
  [Terrain.Snow]: { name: 'Snowfield', moveCost: 1.4, buildable: true, color: '#dfe6ea' },
}

export function isPassable(t: Terrain): boolean {
  return TERRAIN[t].moveCost !== Infinity
}

/** Movement cost with an optional road on the tile. Roads halve cost, min 0.5. */
export function moveCost(t: Terrain, road: boolean): number {
  const c = TERRAIN[t].moveCost
  if (c === Infinity) return Infinity
  return road ? Math.max(0.5, c * 0.5) : c
}
